export const getPlaylistIdFromUrl = (win = window) => {
  const params = new URLSearchParams(win.location.search);
  const playlistIdString = params.get('playlistId');
  const playlistId = playlistIdString ? parseInt(playlistIdString, 10) : undefined;
  return playlistId;
};